import { Component, inject } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { Toast, ToastService } from '../../services/toast.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleCheck, faCircleExclamation, faCircleInfo, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';


@Component({
	selector: 'app-toasts',
	imports: [NgbToastModule, FontAwesomeModule],
	template: `
	@for (toast of toastService.toasts; track toast) {
		<ngb-toast
			[class]="'qai-toast-' + toast.type"
			[autohide]="toast.autoHide"
			[delay]="toast.delay || delayByType(toast.type)"
			(mouseenter)="onMouseEnter(toast)"
			(mouseleave)="onMouseLeave(toast)"
			(hidden)="toastService.remove(toast)"
		>
			@if (toast.autoHide === false) {
				<button type="button" class="btn-close float-end" aria-label="Close" (click)="toastService.remove(toast)"></button>
			}

			<div>
				<fa-icon
				[icon]="iconByType(toast.type)"
				size="lg"
				class="pe-2">
				</fa-icon>

				<span>{{ toast.message }}</span>
				<span>{{ toast.error?.error?.detail || toast.error?.error?.status }}</span>
			</div>
	
		</ngb-toast>
	}
	`,
	host: { class: 'toast-container position-fixed bottom-0 end-0 p-3', style: 'z-index: 1200' },
	styleUrl: './toasts-container.component.scss'
})
export class ToastsContainer {
	toastService = inject(ToastService);

	iconByType(type: Toast['type']): IconDefinition {
		switch (type) {
			case 'success':
				return faCircleCheck;
			case 'warning':
				return faCircleExclamation;
			case 'error':
				return faTriangleExclamation;
			case 'info':
			default:
				return faCircleInfo;
		}
	}

	delayByType(type: Toast['type']): number {
		return type === 'error' ? 15000 : 5000;
	}

	onMouseEnter(toast: Toast) {
		if (toast.type === 'error') {
			toast.autoHide = false;
		}
	}

	onMouseLeave(toast: Toast) {
		if (toast.type === 'error') {
			toast.autoHide = true;
		}
	}
}